import React from 'react';
import { useNavigate } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';
import './Dashboard.css';
import './Insights.css';
import { openDocumentUploadBucket } from '../utils/documentUploadLink';

const Insights = ({ onLogout }) => {
  const navigate = useNavigate();

  return (
    <div className="dashboard-page">
      <Header onLogout={onLogout} />

      <div className="page-body">
        <aside className="sidebar mini-sidebar">
          <nav className="sidebar-nav">
            <button onClick={() => navigate('/home')} className="nav-item">
              <i className="fas fa-home"></i><span className="nav-label">Home</span>
            </button>
            <button onClick={() => navigate('/my-work')} className="nav-item">
              <i className="fas fa-briefcase"></i><span className="nav-label">My Work</span>
            </button>
            <button onClick={() => navigate('/crm')} className="nav-item">
              <i className="fas fa-address-book"></i><span className="nav-label">FNOL</span>
            </button>
            <button onClick={() => navigate('/claims')} className="nav-item">
              <i className="fas fa-file-shield"></i><span className="nav-label">Claim</span>
            </button>
            <button onClick={() => navigate('/ops-dashboard')} className="nav-item">
              <i className="fas fa-tachometer-alt"></i><span className="nav-label">Ops Dashboard</span>
            </button>
            <button onClick={() => navigate('/claims?tab=quality-score')} className="nav-item quality-score-nav-item">
              <i className="fas fa-clipboard-check"></i><span className="nav-label">QA</span>
            </button>
            <button onClick={() => navigate('/agent-dashboard')} className="nav-item">
              <i className="fas fa-gauge-high"></i><span className="nav-label">AI Agent Dashboard</span>
            </button>
            <button onClick={openDocumentUploadBucket} className="nav-item">
              <i className="fas fa-file-arrow-up"></i><span className="nav-label">Document Upload</span>
            </button>
          </nav>
          <div className="sidebar-footer">
            <button onClick={onLogout} className="nav-item logout-btn">
              <i className="fas fa-sign-out-alt"></i><span className="nav-label">Logout</span>
            </button>
          </div>
        </aside>

        <main className="db-content insights-main" aria-label="Insights"></main>
      </div>

      <Footer />
    </div>
  );
};

export default Insights;
